const setFieldValues9142B = ({
  formApi,
  selectedRegistrationNumber,
  machine_name,
  rnLinkingDataField = null,
  isPrefill = true,
  formMsaValue = null, // New parameter to accept the original MSA value from form
}) => {
  const rnLinkingDataFields = [
    "empFein",
    "jobMsa",
    "tempneedNature",
    "numberOfWorkers",
    "tempneedStartDayOfYear",
    "tempneedEndDayOfYear",
  ];
  if (isPrefill) {
    formApi.change(machine_name, selectedRegistrationNumber.registrationNumber);
    if (!!rnLinkingDataField) {
      const rnLinkingData = {};
      rnLinkingDataFields.forEach((fieldName) => {
        // If this is the jobMsa field and we have a formMsaValue, use that instead
        if (fieldName === "jobMsa" && formMsaValue) {
          rnLinkingData[fieldName] = formMsaValue;
        } else {
          rnLinkingData[fieldName] = selectedRegistrationNumber?.[fieldName];
        }
      });
      formApi.change(rnLinkingDataField, rnLinkingData);
    }
  } else {
    formApi.change(machine_name, null);
    formApi.change(rnLinkingDataField, null);
  }
};

export default setFieldValues9142B;
